import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const DropDownComponent = ({
  options,
  selectedOption,
  onChange,
  dropDownStyle,
  isMultiSelectionEnabled = false,
  placeholder = '',
  isRequired = false,
  errorType = 0,
  isDisabled = false,
  isSearchable = false,
  'data-testid': dataTestId,
  ...props
}) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  const selectOptions = options.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  let updatedClassName = dropDownStyle;
  if (errorType === 1 || errorType === 3) {
    updatedClassName = 'red-borderDropdown';
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 0, // Set the border radius to 0px
      border: state.isFocused ? '2px solid rgb(38, 132, 255)' : '2px solid #d8d8d8',
      height: '50px',
      boxShadow: 'none',
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      backgroundColor: state.isSelected ? '#00148c' : 'transparent',
      color: state.isSelected ? '#ffffff' : '#53565a',
      borderBottom: '2px solid #ccc',
      fontWeight: '700',
      '&:hover': {
        backgroundColor: '#00148c', // Change background color on hover
        color: '#ffffff',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#54565a', // Change this to your desired color
      fontSize: '14px', // Optional: Change the font size
      fontWeight: '700', // Optional: Add any other styles you want
    }),
  };

  return (
    <div data-testid={dataTestId}>
      {' '}
      <Select
        isMulti={isMultiSelectionEnabled}
        value={selectedOption}
        onChange={handleChange}
        options={selectOptions}
        placeholder={placeholder}
        required={isRequired}
        onKeyDown={handleKeyDown}
        className={updatedClassName}
        isSearchable={isSearchable}
        styles={customStyles}
        isDisabled={isDisabled}
        {...props}
      />
    </div>
  );
};

DropDownComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  errorType: PropTypes.number,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  isMultiSelectionEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  dropDownStyle: PropTypes.string,
  selectedOption: PropTypes.any,
  'data-testid': PropTypes.string,
};

export default DropDownComponent;
